var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper bg-white",class:{'onSidebarOpen' : _vm.sidebarVisible}},[_c('payment-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }